<template>
    <v-col cols="12" class="MyOffers mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium font-family-1">Tus Ofertas de Energía con <a href="#" class="text-decoration-none">Neocity Energía</a></h2>

                                <v-row align="center" class="caption">
                                  
                                    <v-col cols="6" lg="2">
                                        <v-select
                                                class="select-filter"
                                                :items="['Wallmart', 'Neocity', 'Colun', 'Nestle']"
                                                filled
                                                label="Estás Administrando"
                                                background-color="#0172C0"
                                            
                                                dark

                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6" lg="2" >

                                        <v-select
                                                class="select-filter"
                                                :items="['I Region ', 'II Region', 'III Region', 'IV Region']"
                                                filled
                                                label="Ubicacion"
                                                background-color="#0172C0"
                                                dark

                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" lg="2" >
                                        <div class="mx-auto">
                                            bloques
                                            <v-chip
                                                    class="ma-2"
                                                    color="#004E85"
                                                    label
                                                    text-color="white"
                                            >
                                                A
                                            </v-chip>
                                            <v-chip
                                                    class="ma-2"
                                                    color="#FF9A1B"
                                                    label
                                                    text-color="white"
                                            >
                                                B
                                            </v-chip>
                                            <v-chip
                                                    class="ma-2"
                                                    color="#0172C0"
                                                    label
                                                    text-color="white"
                                            >
                                                C
                                            </v-chip>
                                        </div>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="12" lg="2" class="d-flex align-center justify-end">

                                        <span>Vista de Ofertas</span>
                                        <v-btn icon @click="viewMode = 'table'" class="" tile large :color="viewMode == 'table' ? 'blue' : 'grey'" dense icon>
                                            <v-icon>mdi-view-list</v-icon>
                                        </v-btn>
                                        <v-btn icon @click="viewMode = 'card'" class="" tile large :color="viewMode == 'card' ? 'blue' : 'grey'" dense icon>
                                            <v-icon>mdi-view-grid</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" lg="2">
                                          <v-text-field
                                            class="buscador tipo1"
                                            placeholder="Buscar en"
                                            outlined
                                            append-icon="mdi-magnify"
                                    ></v-text-field>
                                    </v-col>
                                   
                                </v-row>


                    <v-row class="mt-5" v-if="viewMode == 'table'">
                            

                                     <v-data-table
                                                :headers="closings.headers"
                                                :items="closings.data"
                                                item-key="code"
                                                :item-class="classColorReturn"
                                                :items-per-page="5"
                                                class="elevation-1"
                                                :search="closings.search"
                                                dense
                                                show-select
                                        >


                                            <template v-slot:item.code="{ item }">
                                                {{ item.code }}
                                                <v-progress-linear value="10"></v-progress-linear>
                                            </template>
                                            <template v-slot:item.TimeBlocks="{ item }">
                                                <v-col class="d-inline-flex">
                                                    <v-chip v-for="(block,key) in item.TimeBlocks"
                                                            class="ma-1 "
                                                            :color="block === 'A' ? '#004E85': block === 'B' ? '#FF9A1B' : block === 'C' ? '#0172C0' : 'grey'  "
                                                            label
                                                            :key="item.code+'-'+key"
                                                            dense
                                                            small
                                                            text-color="white"
                                                    >
                                                        {{block}}
                                                    </v-chip>
                                                </v-col>
                                            </template>
                                            <template v-slot:item.GeneratorResponse="{ item }">
                                                <v-icon color="green" v-if="item.GeneratorResponse === true">
                                                    mdi-check-box-outline
                                                </v-icon>
                                                <v-icon color="red" v-if="item.GeneratorResponse === false">
                                                    mdi-close-box-outline
                                                </v-icon>
                                                <v-icon color="grey" v-if="item.GeneratorResponse === null">
                                                    mdi-checkbox-blank-outline
                                                </v-icon>
                                            </template>
                                            <template v-slot:item.ContractClosing="{ item }">
                                                <v-icon color="green" v-if="item.ContractClosing === true">
                                                    mdi-check-box-outline
                                                </v-icon>
                                                <v-icon color="red" v-if="item.ContractClosing === false">
                                                    mdi-close-box-outline
                                                </v-icon>
                                                <v-icon color="grey" v-if="item.ContractClosing === null">
                                                    mdi-checkbox-blank-outline
                                                </v-icon>
                                            </template>
                                            <template v-slot:item.SupplierInfo="{ item }">
                                                <v-col class="d-inline-flex">
                                                    <v-icon color="grey">
                                                        mdi-clock-time-four-outline
                                                    </v-icon>
                                                    <v-icon color="grey">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-col>
                                            </template>
                                            <template v-slot:item.Manage="{ item }">
                                                <v-btn 
                                                raised
                                                :color="item.Manage.color"
                                                small
                                                dark
                                                class="">{{item.Manage.text}}</v-btn>
                                            </template>

                                        </v-data-table>
                                </v-row>

                    <v-data-iterator
                            v-else-if="viewMode == 'card'"
                            :items="items"
                            :items-per-page.sync="itemsPerPage"
                            hide-default-footer
                    >

                        <template v-slot:default="props">
                            <v-row class="justify-center flex-xl-wrap">
                                <div >
                                    <v-card :key="'card-offers-add'"
                                            class="outline-0 py-12 px-3 card-max-width text-center overflow-hidden rounded-xl"
                                            @click="showDialog('Crear')"
                                            color="#FFF" min-height="462px">
                                        <v-row class="py-12">
                                            <v-col>
                                                <v-icon size="80">mdi-plus</v-icon>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <a href="#" class="">Agregar Nuevo Punto</a>
                                            <v-btn
                                            class="mt-6"
                                         @click.stop="$refs.uploadFile.dialog.show = true"
                                           color="green"
                                           outlined
                                           
                                            ><v-icon>mdi-microsoft-excel</v-icon> Carga Masiva CSV</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </div>
                                <div
                                        v-for="(item,key) in props.items"
                                        :key="item.name"
                                        @click="showDialog('Editar')"
                                >
                                    <v-card :key="'card-offers-'+key"
                                            class="outline-0 card-max-width py-6 px-3 text-center overflow-hidden rounded-xl"
                                            color="#FFF">

                                        <v-img
                                                class="mx-auto"
                                                max-width="70%"
                                                alt="Neocity Logo"
                                                src="@/assets/images/neocity-logo.png"
                                                contain
                                        ></v-img>
                                        <v-col class="mx-auto" cols="8">
                                            <b>
                                                A - 1000
                                                X. Los Lagos, 220Kv
                                                +50 MW
                                            </b>
                                        </v-col>

                                        <div class="mx-auto">
                                            <v-chip
                                                    class="ma-2"
                                                    color="#004E85"
                                                    label
                                                    text-color="white"
                                            >
                                                A
                                            </v-chip>
                                            <v-chip
                                                    class="ma-2"
                                                    color="#FF9A1B"
                                                    label
                                                    text-color="white"
                                            >
                                                B
                                            </v-chip>
                                            <v-chip
                                                    class="ma-2"
                                                    color="#0172C0"
                                                    label
                                                    text-color="white"
                                            >
                                                C
                                            </v-chip>
                                        </div>
                                        <div class="mx-auto">
                                            <b>6 Meses</b>
                                        </div>

                                        <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                        <v-rating
                                                :value="'4'"
                                                readonly
                                                background-color="orange lighten-3"
                                                color="orange"
                                                class="pb-5"
                                        >

                                        </v-rating>
                                        <v-divider></v-divider>
                                        <div class="pt-6">
                                            <v-btn class="px-1"  text small color="primary">Editar</v-btn>
                                            <v-btn class="px-1"  @click.stop="" text small color="primary">Duplicar</v-btn>
                                            <v-btn  class="px-1" @click.stop="" text small color="primary">Eliminar</v-btn>
                                        </div>

                                        <v-col cols="1" class="mx-auto pa-0">
                                            <v-switch @click.stop="" class="pa-0" :value="true" ></v-switch>
                                        </v-col>

                                    </v-card>

                                </div>
                            </v-row>
                        </template>

                        <template v-slot:footer>
                            <v-row class="mt-2" align="center" justify="center">
                                <span class="grey--text">Ofertas por pagina</span>
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                dark
                                                text
                                                color="primary"
                                                class="ml-2"
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                            {{ itemsPerPage }}
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                                v-for="(number, index) in itemsPerPageArray"
                                                :key="index"
                                                @click="updateItemsPerPage(number)"
                                        >
                                            <v-list-item-title>{{ number }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                                <v-spacer></v-spacer>

                                <span
                                        class="mr-4
                                    grey--text"
                                >
                                    Pagina {{ page }} de {{ numberOfPages }}
                                  </span>
                                <v-btn
                                        fab
                                        dark
                                        x-small
                                        color="blue darken-3"
                                        class="mr-1"
                                        @click="formerPage"
                                >
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-btn
                                        fab
                                        dark
                                        x-small
                                        color="blue darken-3"
                                        class="ml-1"
                                        @click="nextPage"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-row>
                        </template>
                    </v-data-iterator>

                </v-card>
            </v-col>
        </v-row>

        <v-dialog
                v-model="dialog.show"
                width="750px"

        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-left">
                   {{dialog.title}} Detalle de la Oferta de Energía
                </v-card-title>
                <v-card-text>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Empresa</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['NEOCITY ENERGÍA']"
                                    label="Seleccione una Empresa"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 elevation-1"
                                    tile
                                    height="150px"
                                    width="150px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="120px"
                                       width="120px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                            <v-text-field

                                    label="Nombre de la Oferta"
                                    value="X. Los Lagos - 1 / 6m"
                                    dense
                            ></v-text-field>
                            <div class="mx-auto">
                                <v-chip
                                        class="ma-2 py-5"
                                        color="#004E85"
                                        label
                                        text-color="white"
                                >
                                    Bloque A <br>
                                    0 a 8 am.
                                </v-chip>
                                <v-chip
                                        class="ma-2 py-5"
                                        color="#FF9A1B"
                                        label
                                        text-color="white"
                                >
                                    Bloque B <br>
                                    8 a 20 pm.
                                </v-chip>
                                <v-chip
                                        class="ma-2 py-5"
                                        color="#0172C0"
                                        label
                                        text-color="white"
                                >
                                    Bloque C <br>
                                    20 a 24 pm.
                                </v-chip>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Región/es</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['V Región']"
                                    label="Seleccione una Región"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Duración del Contrato</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['6 Meses']"
                                    label="Seleccione una Duración"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Cantidad de Energía</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['150 GWh']"
                                    label="Seleccione una Cantidad"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Tamaño de la oferta</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['opcion 1','opcion 2']"
                                    label="Seleccione el Tamaño de la oferta"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Precio de Energía</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    style="color: green !important;"
                                    placeholder="Precio de Energía"
                                    value="30 USD/MWh en 220kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption pl-7 px-3 border-bottom-1" style="height: 31px; ">Recargo de Energía</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="3">
                            <v-text-field
                                    style="color:green !important;"
                                    placeholder="Precio de Energía"
                                    value="+2% 110 Kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="3">
                            <v-text-field
                                    style="color: green !important;"
                                    placeholder="Precio de Energía"
                                    value="+3% 66 Kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="2">
                            <v-text-field
                                    style="color: green !important;"
                                    placeholder="Precio de Energía"
                                    value="+5% 23 Kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Precio de Potencia</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Traspaso de costos, máx. 8USD/KW mes','opcion 2']"
                                    label="Seleccione el Precio de Potencia"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Peajes</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Traspaso de costos, máx. 7USD/MKW','opcion 2']"
                                    label="Seleccione el Precio de Peajes"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Servicios Complementarios</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Traspaso de costos, máx. 1USD/MKW ','opcion 2']"
                                    label="Seleccione Servicios Complementarios"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Indexacion</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Sin indexación / CPI Semestral','opcion 2']"
                                    label="Seleccione Indexacion"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            outlined
                            @click="dialog.show = false"
                            class="pa-4"

                    >
                        Editar
                    </v-btn>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.show = false"
                            class="pa-4"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <upload-file-component :titleDialog="'Cargar Puntos de Retiro'" :formatFile="'csv'" ref="uploadFile"></upload-file-component>

    </v-col>
</template>

<script>
import UploadFileComponent from '@/components/system/UploadFileComponent.vue';

    export default {
        name: 'MyOffers.vue',
        components: {
            UploadFileComponent
        },
        data: () => ({
            viewMode:'card',
            dialog:{
                show:false,
                title:'',
            },
            itemsPerPageArray: [2,4, 8, 12],
            search: '',
            filter: {},
            sortDesc: false,
            page: 1,
            itemsPerPage: 5,
            items: [
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'
                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                  {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
            ],
            closings:{
                    search:'',
                    headers: [
                        { text: 'Código', value: 'code' },
                        { text: 'Región', value: 'supplier' },
                        { text: 'Nivel de Tensión(Kv)', value: 'EnergyPrice' },
                        { text: 'Periodo de suministro (Meses)', value: 'SupplyPeriod' },
                        { text: 'Bloques Horarios', value: 'TimeBlocks' },
                        { text: 'Potencia maxima ofrecida (Mw)', value: 'PricePower' },
                        { text: 'Precio Energia (USD/MW)', value: 'PricePower' },
                        { text: 'Precio Potencia (USD/MW-mes)', value: 'MonthlyAccount' },
                        { text: 'Tipo de Tecnoloigia', value: 'TypeOfTechnology' },
                        { text: 'Oferta Activa', value: 'GeneratorResponse', class:'rotateTh' },
                        { text: 'visualizacion de la oferta', value: 'SupplyPeriod' , class:'rotateTh'},
                        { text: 'Inicio de la Oferta', value: 'inicio' },
                        { text: 'Termino de la Oferta', value: 'termino' },

                    ],
                    data: [
                        {
                            color:'',
                            code: 'A-1000',
                            supplier: 'VIII',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:false,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            inicio:'26/12/2020',                            
                            termino:'31/12/2020',
                          
                        },
                        {
                            color:'',
                            code: 'A-1002',
                            supplier: 'RM',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            inicio:'26/12/2020',                            
                            termino:'31/12/2020',
                           
                        },
                        {
                            color:'blue lighten-5',
                            code: 'A-1003',
                            supplier: 'II',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:false,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            inicio:'26/12/2020',                            
                            termino:'31/12/2020',
                           
                        },
                        {
                            color:'red lighten-5',
                            code: 'A-1004',
                            supplier: 'V',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:null,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            inicio:'26/12/2020',                            
                            termino:'31/12/2020',
                           
                        },
                        {
                            color:'grey lighten-3',
                            code: 'A-1005',
                            supplier: 'IV',
                            EnergyPrice:'30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: 6,
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:null,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            inicio:'26/12/2020',                            
                            termino:'31/12/2020',
                           
                        },
                    ],
                },
        }),
        computed: {
            numberOfPages () {
                return Math.ceil(this.items.length / this.itemsPerPage)
            },
            filteredKeys () {
                return this.keys.filter(key => key !== `Name`)
            },
        },
        methods: {
            showDialog(type){
                this.dialog.show = true;
                this.dialog.title = type;
            },
            nextPage () {
                if (this.page + 1 <= this.numberOfPages) this.page += 1
            },
            formerPage () {
                if (this.page - 1 >= 1) this.page -= 1
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
        },
        created: function () {
            this.$emit('SetcolorMenu', 'primary');
        }
    }
</script>